import { render } from "./produto.vue?vue&type=template&id=7de4bdb4"
import script from "./produto.vue?vue&type=script&lang=js"
export * from "./produto.vue?vue&type=script&lang=js"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__